<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/team")
          i.fa.fa-users
          span.ml-1 {{ $tc("ui.teams", 1) }}
      b-breadcrumb-item
        router-link(to="/list/mapteam")
          i.fa.fa-link
          span.ml-1 {{ $t("ui.map_team") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-link
                    b-form-select(v-model="mapped" @change="changeMap")
                      option(value="false") {{ $t('ui.not_mapped') }}
                      option(value="true") {{ $t('ui.mapped') }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required ref="team_name" type="text" v-model="teamName" :placeholder="$t('message.search_by_team_name')").mr-2
                //- div.col-md-3.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-sort
                //-     b-form-select(v-model="sortKey")
                //-       option(value="team_id") {{ $t('ui.id') }}
                //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                //-       option(value="team_name") {{ $tc("ui.teams", 1) }}
                //-     b-form-select(v-model="sortType")
                //-       option(value="asc") {{ $t("ui.ascending") }}
                //-       option(value="desc") {{ $t("ui.descending") }}
                div.col-md-4.mb-1
                  sync.mb-1.mr-2(@clicked="getTeamList()")
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getTeamList()"
                    variant="success"
                    size="sm"
                    ).mb-1.mr-2
                  //- SubmitButton(
                  //-   :loading="loading"
                  //-   icon="fa fa-unlink"
                  //-   :text="$t('ui.unmap')"
                  //-   type="button"
                  //-   @click="unmapTeam()"
                  //-   variant="secondary"
                  //-   size="sm"
                  //-   v-if="firstTeamIdSelected!='' && secondTeamIdSelected !='' && curMappedValue == 'true'"
                  //- ).mb-1.mr-2
        div.card-body
          div.row.mb-5
            // SBO
            div.col-6
              div.row.mb-2
                div.col-3
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-sitemap
                    b-input(:value="firstProvider" readonly)
                    b-input(:value="filterFirstTeamListLength" readonly)
                div.col-7
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required type="text" v-model="firstTeamSearch" :placeholder="$t('message.search_by_team_name')").mr-2
                    b-form-radio-group(
                      buttons
                      v-model="teamFilterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
                div.col-2.text-right
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.sbo_prefer')"
                    type="button"
                    @click="mapTeam('first')"
                    variant="secondary"
                    size="sm"
                    v-if="firstTeamIdSelected!='' && secondTeamIdSelected !='' && curMappedValue == 'false'"
                  )
              div.row.mb-1
                div.col-12.clusterize
                  div#tblFirstTeam.clusterize-scroll(style="overflow-x: hidden !important;")
                    table.tablex(v-columns-resizable)
                      thead
                        tr
                          th.sticky-position(width=100 @click="sortOrder('team_id', 'first')")
                            span {{ $t('ui.id') }}
                            i(:class="changeSortKey('team_id', 'first')")
                          th.sticky-position(width=100 @click="sortOrder('sport_type', 'first')")
                            span {{ $tc('ui.sports', 1) }}
                            i(:class="changeSortKey('sport_type', 'first')")
                          th.sticky-position(@click="sortOrder('team_name', 'first')")
                            span {{ $t('ui.name') }}
                            i(:class="changeSortKey('team_name', 'first')")
                      tbody.clusterize-content
                        tr(
                          v-for="(firstTeamInfo, index) in filterFirstTeamList"
                          @click="rowSelect(firstTeamInfo, 'firstTeam')"
                          :class="{ 'selectedRow' : selectedRow(firstTeamInfo, 'firstTeam') }"
                          :ref="firstTeamInfo.team_id"
                          )
                          td
                            span {{ firstTeamInfo.team_id }}
                          td
                            span {{ firstTeamInfo.sport_type }}
                          td
                            span(:title="firstTeamInfo.team_name") {{ firstTeamInfo.team_name }}
            // IBC / CMD
            div.col-6
              div.row.mb-2
                div.col-3
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-sitemap
                    b-form-select(v-model="secondProvider")
                      option(value="IBC") {{ $t('ui.ibc') }}
                      //- option(value="CMD" disabled) {{ $t('ui.cmd') }}
                    b-input(:value="filterSecondTeamListLength" readonly)
                div.col-7
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required type="text" v-model="secondTeamSearch" :placeholder="$t('message.search_by_team_name')").mr-2
                    b-form-radio-group(
                      buttons
                      v-model="teamFilterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
                div.col-2.text-right
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.ibc_prefer')"
                    type="button"
                    @click="mapTeam('second')"
                    variant="secondary"
                    size="sm"
                    v-if="firstTeamIdSelected!='' && secondTeamIdSelected !='' && curMappedValue == 'false'"
                  )
              div.row.mb-1
                div.col-12.clusterize
                  div#tblSecondTeam.clusterize-scroll(style="overflow-x: hidden !important;")
                    table.tablex(v-columns-resizable)
                      thead
                        tr
                          th.sticky-position(width=100 @click="sortOrder('team_id', 'second')")
                            span {{ $t('ui.id') }}
                            i(:class="changeSortKey('team_id', 'second')")
                          th.sticky-position(width=100 @click="sortOrder('sport_type', 'second')")
                            span {{ $tc('ui.sports', 1) }}
                            i(:class="changeSortKey('sport_type', 'second')")
                          th.sticky-position(@click="sortOrder('team_name', 'second')")
                            span {{ $t('ui.name') }}
                            i(:class="changeSortKey('team_name', 'second')")
                      tbody.clusterize-content
                        tr(
                          v-for="(secondTeamInfo, index) in filterSecondTeamList"
                          @click="rowSelect(secondTeamInfo, 'secondTeam')"
                          :class="{ 'selectedRow' : selectedRow(secondTeamInfo, 'secondTeam') }"
                          :ref="secondTeamInfo.team_id"
                          )
                          td
                            span {{ secondTeamInfo.team_id }}
                          td
                            span {{ secondTeamInfo.sport_type }}
                          td
                            span(:title="secondTeamInfo.team_name") {{ secondTeamInfo.team_name }}

</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import VueScrollTo from "vue-scrollto";
import sync from "@/components/sync.vue";
import pako from "pako";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    VueScrollTo,
    sync
  },
  data: () => ({
    loading: false,
    sportType: 1,
    sportList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    firstTeamList: [],
    secondTeamList: [],
    firstProvider: "SBO",
    secondProvider: "IBC",
    curMappedValue: "",
    mapped: "false",
    firstTeamIdSelected: "",
    secondTeamIdSelected: "",
    teamFilterBy: "name",
    firstSortKey: "team_name",
    firstSortType: "asc",
    secondSortKey: "team_name",
    secondSortType: "asc",
    fts: "",
    sts: "",
    teamName: "",
  }),
  computed: {
    filterFirstTeamListLength() {
      if (this.filterFirstTeamList) {
        return this.filterFirstTeamList.length;
      } else {
        return 0;
      }
    },
    filterFirstTeamList() {
      return this.firstTeamList.filter(item => {
        if (this.teamFilterBy == 'name')
          return item.team_name.toLowerCase().indexOf(this.firstTeamSearch.toLowerCase()) > -1;
        else if (this.teamFilterBy == 'id')
          return item.team_id.toString().toLowerCase().indexOf(this.firstTeamSearch.toLowerCase()) > -1;
      })
      .sort((a, b) => {
        if (this.firstSortType == 'asc')
          return a[this.firstSortKey] > b[this.firstSortKey] ? 1 : -1;
        else
          return a[this.firstSortKey] < b[this.firstSortKey] ? 1 : -1;
      });
    },
    firstTeamSearch:
    {
      get() {
        return this.fts;
      },
      set(value) {
        this.fts = value;
        this.sts = value;
      }
    },
    secondTeamSearch:
    {
      get() {
        return this.sts;
      },
      set(value) {
        this.sts = value;
      }
    },
    filterSecondTeamListLength() {
      if (this.filterSecondTeamList) {
        return this.filterSecondTeamList.length;
      } else {
        return 0;
      }
    },
    filterSecondTeamList() {
      return this.secondTeamList.filter(item => {
        if (this.teamFilterBy == 'name')
          return item.team_name.toLowerCase().indexOf(this.secondTeamSearch.toLowerCase()) > -1;
        else if (this.teamFilterBy == 'id')
          return item.team_id.toString().toLowerCase().indexOf(this.secondTeamSearch.toLowerCase()) > -1;
      })
      .sort((a, b) => {
        if (this.secondSortType == 'asc')
          return a[this.secondSortKey] > b[this.secondSortKey] ? 1 : -1;
        else
          return a[this.secondSortKey] < b[this.secondSortKey] ? 1 : -1;
      });
    }
  },
  beforeDestroy() {
    this.sportList = [];
    this.firstTeamList = [];
    this.secondTeamList = [];
  },
  mounted: function() {
    this.getSportList();
  },
  methods: {
    sortOrder(key, type) {
      if (type == 'first') {
        if (this.firstSortKey == key)
          this.firstSortType = this.firstSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.firstSortKey = key;
          this.firstSortType = 'asc';
        }
      } else if (type == 'second') {
        if (this.secondSortKey == key)
          this.secondSortType = this.secondSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.secondSortKey = key;
          this.secondSortType = 'asc';
        }
      }

    },
    changeSortKey(key, type) {
      if (type == 'first') {
        if (this.firstSortKey != key)
          return 'fas fa-sort';
        else if (this.firstSortKey == key && this.firstSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.firstSortKey == key && this.firstSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'second') {
        if (this.secondSortKey != key)
          return 'fas fa-sort';
        else if (this.secondSortKey == key && this.secondSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.secondSortKey == key && this.secondSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    changeMap: function() {
      this.getTeamList();
    },
    showTooltip: function(e) {
      if (e.srcElement.offsetWidth < e.srcElement.scrollWidth) {
        e.srcElement.title = e.srcElement.innerText;
      }
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapteam
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = [];
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    checkSearchCriteria: function () {
      if (this.teamName.trim().length < 2) {
        return false;
      }

      return true;
    },
    getTeamList: function() {
      if (this.checkSearchCriteria()) {
        this.reset();

        this.curMappedValue = this.mapped;

        let url = config.mapTeamListUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.mapteam,
          sport_id: this.sportType,
          mapped: this.mapped,
          map_from: this.firstProvider.toLowerCase(),
          map_to: this.secondProvider.toLowerCase(),
          team_name: this.teamName.trim(),
          sort_key: this.sortKey,
          sort_type: this.sortType
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            // Success
            this.loading = false;
            try {
              if (response) {
                // console.log(response);
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.firstTeamList = [];
                  this.secondTeamList = [];
                  this.firstTeamList = response.data.tbl_map_team_list.Table;
                  this.secondTeamList = response.data.tbl_map_team_list.Table1;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            // Error
            this.loading = false;
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.firstTeamList = [];
        this.secondTeamList = [];
        this.$refs.team_name.$el.focus();
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.teamNameMinTwoChar"), "error");
      }
    },
    selectedRow: function(info, type) {
      if (type == "firstTeam") {
        if (this.firstTeamIdSelected == info.team_id) return true;
      } else if (type == "secondTeam") {
        if (this.secondTeamIdSelected == info.team_id) return true;
      }

      return false;
    },
    rowSelect: function(teamInfo, type) {
      if (this.curMappedValue == "true") {
        this.firstTeamIdSelected = teamInfo.sbo_map;

        if (this.secondProvider.toLowerCase() == "ibc") this.secondTeamIdSelected = teamInfo.ibc_map;
        else if (this.secondProvider.toLowerCase() == "cmd") this.secondTeamIdSelected = teamInfo.cmd_map;

        var VueScrollTo = require("vue-scrollto");

        var options = {
          container: type == "firstTeam" ? "#tblSecondTeam" : "#tblFirstTeam",
          offset: -250
        };

        var elem = type == "firstTeam" ? this.$refs[this.secondTeamIdSelected][0] : this.$refs[this.firstTeamIdSelected][0];

        VueScrollTo.scrollTo(elem, "500", options);
      } else {
        if (type == "firstTeam") {
          setTimeout(() => {
            this.firstTeamIdSelected = teamInfo.team_id;
          }, 10);
        } else if (type == "secondTeam") {
          setTimeout(() => {
            this.secondTeamIdSelected = teamInfo.team_id;
          }, 10);
        }
      }
    },
    mapTeam: function(type) {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.map_team"),
          text: this.$t("message.map_team_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMapTeam(type);
          }
        });
    },
    confirmMapTeam: function(type) {
      let url = "";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapteam
      };

      if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "ibc") {
        url = config.mapTeamSBOIBCUrl();
        json.sbo_id = this.firstTeamIdSelected;
        json.ibc_id = this.secondTeamIdSelected;
        json.prefer_id = type == 'first' ? this.firstTeamIdSelected : this.secondTeamIdSelected;
        json.prefer_provider = type != 'first' ? 'IBC' : 'SBO';
      } else if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "cmd") {
        url = config.mapTeamSBOCMDUrl();
        json.sbo_id = this.firstTeamIdSelected;
        json.cmd_id = this.secondTeamIdSelected;
        json.prefer_id = type == 'first' ? this.firstTeamIdSelected : this.secondTeamIdSelected;
        json.prefer_provider = type != 'first' ? 'IBC' : 'SBO';
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.removeTeamFromList();
                // this.$helpers.showDialog(this.$t("ui.combine.map_team"), this.$t("message.success"), "success");
                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    unmapTeam: function() {
      let url = "";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapteam
      };

      if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "ibc") {
        url = config.unmapTeamSBOIBCUrl();
        json.sbo_id = this.firstTeamIdSelected;
        json.ibc_id = this.secondTeamIdSelected;
      } else if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "cmd") {
        url = config.unmapTeamSBOCMDUrl();
        json.sbo_id = this.firstTeamIdSelected;
        json.cmd_id = this.secondTeamIdSelected;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.removeTeamFromList();
                // this.$helpers.showDialog(this.$t("ui.combine.unmap_team"), this.$t("message.success"), "success");
                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    removeTeamFromList: function() {
      let i = this.firstTeamList
        .map(flInfo => {
          return flInfo.team_id;
        })
        .indexOf(this.firstTeamIdSelected);
      this.firstTeamList.splice(i, 1);

      let j = this.secondTeamList
        .map(slInfo => {
          return slInfo.team_id;
        })
        .indexOf(this.secondTeamIdSelected);
      this.secondTeamList.splice(j, 1);

      this.firstTeamIdSelected = "";
      this.secondTeamIdSelected = "";
    },
    reset: function() {
      this.firstTeamIdSelected = "";
      this.secondTeamIdSelected = "";
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>

tr,
td {
  cursor: pointer;
}
</style>